import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert,
  Box,
  Stack,
  ToggleButtonGroup,
  ToggleButton
} from "@mui/material";
import { motion } from "framer-motion";
import axios from "axios";
import Header from "../components/header";
import Footer from "../components/footer";
import getApiBase from "../components/getApiBase";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState(null);
  const [rolesFromBackend, setRolesFromBackend] = useState([]);
  const [message, setMessage] = useState("");
  const [feedback, setFeedback] = useState({ open: false, success: true });
  const [loading, setLoading] = useState(false);

  const handleRoleSelect = (event, newRole) => {
    if (newRole !== null) {
      setRole(newRole);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${getApiBase()}/api/auth/forgot-password`, {
        email,
        role,
      });
      
      if (res.data.roles?.length > 1) {
        setRolesFromBackend(res.data.roles);
        setMessage(res.data.message);
        setFeedback({ open: true, success: false });
      } else {
        setMessage("Check your email for the reset link.");
        setFeedback({ open: true, success: true });
      }
    } catch (error) {
      const errMsg =
        error.response?.data?.message || "Error sending reset email.";
      setMessage(errMsg);
      setFeedback({ open: true, success: false });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#ffffff" }}>
      <Header />
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "80vh",
        }}
      >
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h4" gutterBottom>
            Forgot Password
          </Typography>
          <form onSubmit={handleSubmit}>
            <Stack spacing={3}>
              <TextField
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                required
              />

              {rolesFromBackend.length > 1 && (
                <>
                  <Typography variant="h6" color="textSecondary">
                    Please select the role you want to reset password for
                  </Typography>
                <ToggleButtonGroup
                  color="primary"
                  value={role}
                  exclusive
                  onChange={handleRoleSelect}
                  fullWidth
                >
                  {rolesFromBackend.map((r) => (
                    <ToggleButton key={r} value={r}>
                      {r.charAt(0).toUpperCase() + r.slice(1)}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </>
              )}

              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </Button>
            </Stack>
          </form>
        </motion.div>
        <Snackbar
          open={feedback.open}
          autoHideDuration={6000}
          onClose={() => setFeedback({ ...feedback, open: false })}
        >
          <Alert
            severity={feedback.success ? "success" : "error"}
            onClose={() => setFeedback({ ...feedback, open: false })}
          >
            {message}
          </Alert>
        </Snackbar>
      </Container>
      <Footer />
    </Box>
  );
};

export default ForgotPassword;
